var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-theme-provider',{attrs:{"theme":_vm.theme}},[(_vm.loadingModuleSettings)?[_c('pui-common-spinner',{attrs:{"message":_vm.$t('platform.app.loading'),"fullscreen":""}})]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }